import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Result } from '@Medology/ng-findalab';
import { Test } from '@models/test';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PscService {
  private http = inject(HttpClient);

  /**
   * Check if a lab supports the given tests.
   *
   * @param {number}   psc_id   The id of the PSC.
   * @param {number[]} test_ids The ids of the tests.
   */
  public verifyTestsAreAvailableAtLab(psc_id: number, test_ids: number[]): Observable<Result[]> {
    return this.http.get<Result[]>(`${environment.analyteCareApi}/api/v1/lab`, {
      params: { 'tests[]': test_ids, lab_id: psc_id },
    });
  }

  /**
   * Get the list of networks that support the given tests.
   *
   * @param {Test[]} tests the tests to filter networks by
   */
  public getTestNetworks(tests: Test[]) {
    if (!(tests?.length > 0)) {
      return of([]);
    }

    return this.http
      .get<{ name: string }[]>(`${environment.analyteCareApi}/api/v1/networks`, {
        params: this.getTestsAsParams(tests),
      })
      .pipe(map((networks) => networks.map((network) => network.name)));
  }

  /**
   * Get the list of labs that support the given tests.
   *
   * @param {Test[]} tests the tests to build params from
   */
  private getTestsAsParams(tests: Test[]): { [key: string]: string } {
    const params = { 'tests[key]': 'id' };

    tests.forEach((test: Test, index: number) => (params[`tests[values][${index}]`] = test.id));

    return params;
  }
}
